"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notificationMediumActionsPayload = exports.identitySecurityActionsPayload = exports.vaultActionsPayload = exports.staticSecretTemplateActionsPayload = exports.passwordPolicyActionsPayload = exports.permissionActionsPayload = exports.roleActionsPayload = exports.policyActionsPayload = exports.notificationMediumActions = exports.vaultActions = exports.staticSecretTemplateActions = exports.passwordPolicyActions = exports.permissionActions = exports.roleActions = exports.policyActions = exports.getBatchEvalTypes = exports.ALLOW = void 0;

var _commonConstants = require("../../utils/common-constants");

var ALLOW = 'Allow';
exports.ALLOW = ALLOW;
var getBatchEvalTypes = {
  GET_BATCH_EVAL_REQUEST: 'GET_BATCH_EVAL_REQUEST',
  GET_BATCH_EVAL_LOADING: 'GET_BATCH_EVAL_LOADING',
  GET_BATCH_EVAL_COMPLETE: 'GET_BATCH_EVAL_COMPLETE'
};
exports.getBatchEvalTypes = getBatchEvalTypes;
var policyActions = {
  create: _commonConstants.createPolicyAction,
  update: _commonConstants.updatePolicyAction,
  delete: _commonConstants.deletePolicyAction,
  read: _commonConstants.readPolicyAction,
  list: _commonConstants.listPolicyAction
};
exports.policyActions = policyActions;
var roleActions = {
  create: 'authz.role.create',
  update: 'authz.role.update',
  delete: 'authz.role.delete',
  read: 'authz.role.read',
  list: 'authz.role.list'
};
exports.roleActions = roleActions;
var permissionActions = {
  create: 'authz.permission.create',
  update: 'authz.permission.update',
  delete: 'authz.permission.delete',
  read: 'authz.permission.read',
  list: 'authz.permission.list'
};
exports.permissionActions = permissionActions;
var passwordPolicyActions = {
  create: 'sm.passwordpolicy.create',
  update: 'sm.passwordpolicy.update',
  delete: 'sm.passwordpolicy.delete',
  read: 'sm.passwordpolicy.read',
  list: 'sm.passwordpolicy.list'
};
exports.passwordPolicyActions = passwordPolicyActions;
var staticSecretTemplateActions = {
  create: 'sm.secrettemplate.create',
  update: 'sm.secrettemplate.update',
  delete: 'sm.secrettemplate.delete',
  read: 'sm.secrettemplate.read',
  list: 'sm.secrettemplate.list'
};
exports.staticSecretTemplateActions = staticSecretTemplateActions;
var vaultActions = {
  create: 'sm.vault.create',
  update: 'sm.vault.update',
  delete: 'sm.vault.delete',
  read: 'sm.vault.read',
  list: 'sm.vault.list'
};
exports.vaultActions = vaultActions;
var notificationMediumActions = {
  list: 'nm.notification.list',
  create: 'nm.notification.create',
  update: 'nm.notification.update',
  delete: 'nm.notification.delete',
  read: 'nm.notification.read'
};
exports.notificationMediumActions = notificationMediumActions;
var policyActionsPayload = [{
  action: _commonConstants.updatePolicyAction,
  resource: '*',
  consumer: 'authz'
}, {
  action: _commonConstants.readPolicyAction,
  resource: '*',
  consumer: 'authz'
}, {
  action: _commonConstants.deletePolicyAction,
  resource: '*',
  consumer: 'authz'
}, {
  action: _commonConstants.createPolicyAction,
  resource: '*',
  consumer: 'authz'
}, {
  action: _commonConstants.listPolicyAction,
  resource: '*',
  consumer: 'authz'
}];
exports.policyActionsPayload = policyActionsPayload;
var roleActionsPayload = [{
  action: 'authz.role.update',
  resource: '*',
  consumer: 'authz'
}, {
  action: 'authz.role.read',
  resource: '*',
  consumer: 'authz'
}, {
  action: 'authz.role.delete',
  resource: '*',
  consumer: 'authz'
}, {
  action: 'authz.role.create',
  resource: '*',
  consumer: 'authz'
}, {
  action: 'authz.role.list',
  resource: '*',
  consumer: 'authz'
}];
exports.roleActionsPayload = roleActionsPayload;
var permissionActionsPayload = [{
  action: 'authz.permission.update',
  resource: '*',
  consumer: 'authz'
}, {
  action: 'authz.permission.read',
  resource: '*',
  consumer: 'authz'
}, {
  action: 'authz.permission.delete',
  resource: '*',
  consumer: 'authz'
}, {
  action: 'authz.permission.create',
  resource: '*',
  consumer: 'authz'
}, {
  action: 'authz.permission.list',
  resource: '*',
  consumer: 'authz'
}];
exports.permissionActionsPayload = permissionActionsPayload;
var passwordPolicyActionsPayload = [{
  action: 'sm.passwordpolicy.update',
  resource: '*',
  consumer: _commonConstants.smConsumer
}, {
  action: 'sm.passwordpolicy.read',
  resource: '*',
  consumer: _commonConstants.smConsumer
}, {
  action: 'sm.passwordpolicy.delete',
  resource: '*',
  consumer: _commonConstants.smConsumer
}, {
  action: 'sm.passwordpolicy.create',
  resource: '*',
  consumer: _commonConstants.smConsumer
}, {
  action: 'sm.passwordpolicy.list',
  resource: '*',
  consumer: _commonConstants.smConsumer
}];
exports.passwordPolicyActionsPayload = passwordPolicyActionsPayload;
var staticSecretTemplateActionsPayload = [{
  action: 'sm.secrettemplate.update',
  resource: '*',
  consumer: _commonConstants.smConsumer
}, {
  action: 'sm.secrettemplate.read',
  resource: '*',
  consumer: _commonConstants.smConsumer
}, {
  action: 'sm.secrettemplate.delete',
  resource: '*',
  consumer: _commonConstants.smConsumer
}, {
  action: 'sm.secrettemplate.create',
  resource: '*',
  consumer: _commonConstants.smConsumer
}, {
  action: 'sm.secrettemplate.list',
  resource: '*',
  consumer: _commonConstants.smConsumer
}];
exports.staticSecretTemplateActionsPayload = staticSecretTemplateActionsPayload;
var vaultActionsPayload = [{
  action: 'sm.vault.update',
  resource: '*',
  consumer: _commonConstants.smConsumer
}, {
  action: 'sm.vault.read',
  resource: '*',
  consumer: _commonConstants.smConsumer
}, {
  action: 'sm.vault.delete',
  resource: '*',
  consumer: _commonConstants.smConsumer
}, {
  action: 'sm.vault.create',
  resource: '*',
  consumer: _commonConstants.smConsumer
}, {
  action: 'sm.vault.list',
  resource: '*',
  consumer: _commonConstants.smConsumer
}];
exports.vaultActionsPayload = vaultActionsPayload;
var identitySecurityActionsPayload = [{
  action: _commonConstants.userTagListAction,
  resource: '*',
  consumer: _commonConstants.identityConsumer
}, {
  action: _commonConstants.tokensListAction,
  resource: '*',
  consumer: _commonConstants.securityAdminConsumer
}];
exports.identitySecurityActionsPayload = identitySecurityActionsPayload;
var notificationMediumActionsPayload = [{
  action: 'nm.notification.list',
  resource: '*',
  consumer: _commonConstants.notificationManager
}, {
  action: 'nm.notification.create',
  resource: '*',
  consumer: _commonConstants.notificationManager
}, {
  action: 'nm.notification.read',
  resource: '*',
  consumer: _commonConstants.notificationManager
}, {
  action: 'nm.notification.delete',
  resource: '*',
  consumer: _commonConstants.notificationManager
}, {
  action: 'nm.notification.update',
  resource: '*',
  consumer: _commonConstants.notificationManager
}];
exports.notificationMediumActionsPayload = notificationMediumActionsPayload;